import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { MENU_POST_ITEM } from '../../../../constants/menu'
import { ROUTE_PATH_LIST_AUTH } from '../../../../constants/route'
import { LOCAL_STORAGE_NAME_TOKEN } from '../../../../constants/storage'
import {
  useInitActions,
  useInitData,
  useInlineNotifications,
  useUk,
} from '../../../../hooks'
import { isHostNameLocalhost } from '../../../../utils/common'
import { setStorageItem } from '../../../../utils/storage'
import { TabList } from '../../../Tab'
import { hasNotifications } from '../../Auth.utils'
import { AuthFooter } from '../../AuthFooter'
import { AuthFormWrapper } from '../../AuthFormWrapper'
import { AuthHeader } from '../../AuthHeader'
import { AuthLicense } from '../../AuthLicense'
import { AuthPanel } from '../../AuthPanel'
import { AuthTitle } from '../../AuthTitle'
import { getRedirectUrlAfterLogin } from '../Login.utils'
import { LoginFormEmail } from '../LoginFormEmail'
import { LoginFormPhone } from '../LoginFormPhone'

import { LOGIN_FORM_TYPE_EMAIL } from './LoginForm.constants'
import { getLoginFormTabs, isLoginEmailTypeActive } from './LoginForm.utils'

import * as styles from './LoginForm.module.css'

function LoginForm() {
  const { resetApp } = useInitActions()

  const { t } = useTranslation()

  const { availableSections } = useInitData()
  const { config: ukConfig } = useUk()
  const registrationEnabled = ukConfig?.free_registration

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const [loginType, setLoginType] = useState(LOGIN_FORM_TYPE_EMAIL)

  const withNotifications = hasNotifications(notifications)

  const titleClassName = classNames(styles.title, {
    [styles.withNotifications]: withNotifications,
  })

  function handleSuccessLogin(response) {
    const currentHostname = window.location.hostname

    setStorageItem(LOCAL_STORAGE_NAME_TOKEN, response.data.key)

    resetApp()

    if (
      currentHostname !== response.data.host &&
      !isHostNameLocalhost(currentHostname)
    ) {
      window.location.replace(
        getRedirectUrlAfterLogin({
          host: response.data.host,
          isNewsboardAvailable: availableSections[MENU_POST_ITEM.uiSectionName],
        })
      )
    }
  }

  return (
    <AuthPanel
      notifications={notifications}
      withNotifications={withNotifications}
    >
      <AuthHeader
        {...(registrationEnabled
          ? {
              description: t('Auth.SignUpDescriptionKey'),
              link: {
                text: t('Auth.SignUpLinkKey'),
                to: ROUTE_PATH_LIST_AUTH.registration,
              },
            }
          : null)}
        notifications={notifications}
      />

      <AuthFormWrapper>
        <AuthTitle
          className={titleClassName}
          title={t('Auth.SignInTitleKey')}
        />

        <TabList
          activeTab={loginType}
          className={styles.tabList}
          getTabs={getLoginFormTabs}
          tabProps={{ className: styles.tab }}
          onSetActiveTab={setLoginType}
        />

        {isLoginEmailTypeActive(loginType) ? (
          <LoginFormEmail
            onRemoveNotification={handleRemoveNotification}
            onSetNotification={handleAddNotification}
            onSuccess={handleSuccessLogin}
          />
        ) : (
          <LoginFormPhone
            onRemoveNotification={handleRemoveNotification}
            onSetNotification={handleAddNotification}
            onSuccessLogin={handleSuccessLogin}
          />
        )}
        <AuthLicense className={styles.license} />
      </AuthFormWrapper>

      <AuthFooter withNotifications={withNotifications} />
    </AuthPanel>
  )
}

export default LoginForm
